import { GradeMappingsSchema } from "@redotech/redo-return-settings-common/grade-mapping";
import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import {
  receivingOutcomeSchema,
  returnsCenterReceivingOutcomesSchema,
} from "@redotech/redo-return-settings-common/receiving-outcome-config";
import { remitModeSchema } from "@redotech/redo-return-settings-common/remit-mode-config";
import {
  returnProcessingLevelSchema,
  returnsCenterProcessingLevelsSchema,
} from "@redotech/redo-return-settings-common/return-processing-level";
import { ReturnsCenterGradeOverridesSchema } from "@redotech/redo-return-settings-common/returns-center-grade-overrides";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getManagedReturnsSettings = unaryRpc({
  name: "getManagedReturnsSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    billing: processingBillingConfigSchema,
    returnProcessingLevel: returnProcessingLevelSchema,
    receivingOutcome: receivingOutcomeSchema.nullable(),
    gradeMappings: GradeMappingsSchema,
    remitMode: remitModeSchema,
    returnsCenterOverrides: z.array(ReturnsCenterGradeOverridesSchema),
    returnsCenterProcessingLevels: returnsCenterProcessingLevelsSchema,
    returnsCenterReceivingOutcomes: returnsCenterReceivingOutcomesSchema,
  }),
});
